import { render, staticRenderFns } from "./VgScanQrCode.vue?vue&type=template&id=0c2c16f9&"
import script from "./VgScanQrCode.vue?vue&type=script&lang=js&"
export * from "./VgScanQrCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports